import { motion } from "framer-motion";
import { MonitorPlay, BookOpen, FolderOpen, PencilLine, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "../lib/images";

const CHECKOUT = "https://pay.hotmart.com/T106758268D?off=8mksx5iz";

const ITEMS = [
  { icon: MonitorPlay, title: "Filminas" },
  { icon: BookOpen, title: "Workbook" },
  { icon: FolderOpen, title: "Recursos complementarios" },
  { icon: PencilLine, title: "Ejercicios prácticos" },
];

export const Library = () => (
  <section id="biblioteca" className="relative overflow-hidden bg-cream py-24 text-navy sm:py-32" data-testid="library-section">
    <div className="container-luxe">
      <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="overline mb-6 flex items-center gap-4 text-gold-deep">
              <span className="h-px w-10 bg-gold-deep" /> Biblioteca Premium
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif text-4xl font-light leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
              Tu mejor versión <span className="italic text-gold-deep">te espera</span>.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-md text-base font-light leading-relaxed text-navy/70 sm:text-lg">
              Cada módulo, cada libro y cada encuentro en vivo son una oportunidad para comprenderte
              mejor, sanar con conciencia y avanzar hacia la vida que siempre ha estado dentro de ti.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <p className="mt-5 max-w-md text-base font-light leading-relaxed text-navy/70 sm:text-lg">
              No importa en qué parte del camino te encuentres. El primer paso comienza cuando decides
              mirar hacia adentro.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <a
              href={CHECKOUT}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold mt-10"
              data-testid="library-cta"
            >
              Entrar a la Biblioteca Premium <ArrowRight size={15} />
            </a>
          </Reveal>

          <Reveal delay={0.35}>
            <div className="mt-12 overflow-hidden rounded-sm border border-gold/30">
              <img src={IMAGES.libraryBg} alt="Biblioteca premium" className="aspect-[16/10] w-full object-cover" />
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          <div className="flex flex-col gap-5 lg:pt-24">
            {ITEMS.map((it, i) => (
              <Reveal key={it.title} delay={i * 0.1}>
                <motion.div
                  whileHover={{ x: 8 }}
                  transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                  className="group flex items-center gap-6 rounded-sm border border-navy/10 bg-white/50 p-6 backdrop-blur-sm"
                  data-testid={`library-item-${i}`}
                >
                  <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-gold/40 text-gold-deep transition-colors group-hover:bg-gold-deep group-hover:text-cream">
                    <it.icon size={20} />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-serif text-2xl font-normal leading-tight">{it.title}</h3>
                  </div>
                </motion.div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
